export class Layer {
    constructor(dependsOn) {
        this.layerGraph = {};
        this._inLayers = null;
        this._updateData = null;
        this.dependsOn = new Set(dependsOn);
        this.originalDependsOn = new Set(dependsOn);
    }
    onDependencyAvailable(dep) {
        this.dependsOn.delete(dep);
    }
    onDependencyUnavailable(dep) {
        if (this.originalDependsOn.has(dep)) {
            this.dependsOn.add(dep);
        }
    }
    canActivate() {
        let dependsOnString = '';
        this.dependsOn.forEach((item) => dependsOnString += ' - ' + item);
        //console.log(`${this.constructor.name} canActivate(). this.dependsOn: ${dependsOnString}`);
        return this.dependsOn.size === 0;
    }
    get data() {
        return this.getLayerData();
    }
    _setLayerGraph(layerGraph) {
        this.layerGraph = layerGraph;
    }
    sendUpdate(event) {
        this.layerGraph.sendUpdate(this, event);
    }
}
//# sourceMappingURL=Layer.js.map